import axios from "axios";
import { TRANSPORT, EXCHANGE, TRACKPARK, GET_BY_ID, TEMPLATE, TRANSPORT_V2 } from "../endpointsConst";

const TransportService = {};

TransportService.getTransport = () =>
    axios.get(TRANSPORT).catch((e) => {
        return new Error(e.response.status);
    });

TransportService.addTransportToExchange = (data) => axios.post(TRANSPORT + EXCHANGE, data);
TransportService.getTransportExchange = (params) =>
    axios.get(TRANSPORT_V2 + EXCHANGE, { params });
TransportService.searchExchange = (params, data) =>
    axios.post(TRANSPORT_V2 + EXCHANGE + "/search", data, { params });
TransportService.deleteExchange = (id) =>
    axios.patch(TRANSPORT + EXCHANGE + `/${id}/soft-delete`);
TransportService.getById = (id, params) =>
    axios.get(TRANSPORT_V2 + EXCHANGE + `/${id}`, { params });
TransportService.toggleActivation = (id) =>
    axios.patch(TRANSPORT + EXCHANGE + `/${id}/active`);
TransportService.exchangeUp = (id) => axios.post(TRANSPORT + EXCHANGE + `/${id}/up-to-top`);

TransportService.addTransportTrackpark = (data) => axios.post(TRANSPORT + TRACKPARK, data);
TransportService.deleteTransportTrackpark = (id) =>
    axios.delete(TRANSPORT + TRACKPARK + `/${id}`);
TransportService.getTransportTrackpark = (params) =>
    axios.get(TRANSPORT + TRACKPARK, { params });
TransportService.getTrackParkTransportData = (id, lang) =>
    axios.get(TRANSPORT + TRACKPARK + GET_BY_ID + `/${id}?lang=${lang}`);

TransportService.getExchangePattern = (id, lang) =>
    axios.get(TRANSPORT + TEMPLATE + `/${id}?lang=${lang}`);
TransportService.saveExchangePattern = (data) => axios.post(TRANSPORT + TEMPLATE, data);
TransportService.updateExchangePattern = (id, data) => axios.patch(TRANSPORT + TEMPLATE + `/${id}`, data);
TransportService.getExchangePatterns = (params) =>
    axios.get(TRANSPORT + TEMPLATE, { params });
TransportService.deleteExchangePattern = (id) =>
    axios.delete(TRANSPORT + TEMPLATE + `/${id}`);

export { TransportService };
